export default __webpack_public_path__ + "static/media/A0006.32ea9d7d.png";